// @ts-expect-error untyped module
import { OfficeLocationType } from '../../../constants/search/Filters';
// @ts-expect-error untyped module
import { translateFilterValue } from '../../../utils/i18n';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import { LanguageIcon } from 'foundations-assets';
import { Text } from 'foundations-components/components/Text';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { Select } from 'foundations-components/transitional/components/Select';
import { Small } from 'foundations-components/transitional/components/Small';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { View } from 'foundations-components/transitional/components/View';
import { WizardStep } from 'foundations-components/transitional/components/Wizard';
import * as Countries from 'marketplace-ui-common/constants/Country';
import { useCallback, useEffect, useMemo, useState } from 'react';
import CountryFlag from 'ui-addon-i18n/components/CountryFlag';
import { COUNTRY } from '../../../constants/search/FilterKey';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const unavailableCountryCodes = ['AN', 'AP'];
export default function FindPartnerWizardCountryStep({
  filters,
  onFilterChange,
  userInsights
}) {
  const [guessed, setGuessed] = useState(null);
  const handleFilterChange = useCallback((value, isGuess) => {
    onFilterChange('country', value);
    setGuessed(isGuess);
  }, [onFilterChange]);
  useEffect(() => {
    if (!filters.country && guessed === null) {
      const guess = (userInsights === null || userInsights === void 0 ? void 0 : userInsights.portalInsights.hqCountry) || (userInsights === null || userInsights === void 0 ? void 0 : userInsights.ipCountry);
      handleFilterChange(guess || 'ANY', !!guess);
    }
  }, [guessed, filters.country, handleFilterChange, userInsights]);
  const options = useMemo(() => {
    const optionsArr = Object.keys(Countries).map(option => ({
      avatar: unavailableCountryCodes.includes(option) ? undefined : /*#__PURE__*/_jsx(CountryFlag, {
        countryCode: option
      }),
      text: translateFilterValue(COUNTRY, option),
      value: option
    }));
    optionsArr.unshift({
      icon: LanguageIcon,
      text: unescapedText('ecosystem-marketplace-solutions-ui.homepage.questionnaire.country.default'),
      value: 'ANY'
    });
    return optionsArr;
  }, []);
  return /*#__PURE__*/_jsxs(WizardStep, {
    children: [/*#__PURE__*/_jsx(Text, {
      as: "h2",
      "data-test-id": "findPartnerWizard-step-3",
      marginBlockEnd: "1100",
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "ecosystem-marketplace-solutions-ui.homepage.questionnaire.country.title"
      })
    }), /*#__PURE__*/_jsx(Select, {
      anchorType: "combined",
      options: options,
      onChange: ({
        target: {
          value
        }
      }) => handleFilterChange(value, false),
      placeholder: /*#__PURE__*/_jsxs(TFlex, {
        align: "center",
        direction: "row",
        children: [/*#__PURE__*/_jsx(View, {
          as: "span",
          marginInlineEnd: "300",
          children: /*#__PURE__*/_jsx(LanguageIcon, {
            size: "300"
          })
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ecosystem-marketplace-solutions-ui.homepage.questionnaire.country.default"
        })]
      }),
      value: filters.country
    }), guessed && /*#__PURE__*/_jsx(Small, {
      marginBlockStart: "300",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ecosystem-marketplace-solutions-ui.homepage.questionnaire.guess"
      })
    }), filters.country !== 'ANY' && /*#__PURE__*/_jsxs(TFlex, {
      align: "center",
      direction: "row",
      marginBlockStart: "600",
      children: [/*#__PURE__*/_jsx(Checkbox, {
        checked: filters.office_location === OfficeLocationType.PHYSICAL,
        onChange: () => onFilterChange('office_location', filters.office_location === OfficeLocationType.PHYSICAL ? 'ANY' : OfficeLocationType.PHYSICAL),
        marginInlineEnd: "200"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ecosystem-marketplace-solutions-ui.homepage.questionnaire.country.office"
      })]
    })]
  });
}